// plugins/measure/index.ts

import type { PluginDefinition } from "../types";
import { MeasurePluginComponent } from "./MeasurePlugin";

export const MeasurePlugin: PluginDefinition = {
  id: "measure",
  Component: MeasurePluginComponent,
};
